import type { ScenarioStep } from '@/components/Scenarios/ScenarioStepsSidebar';

const SCENARIO_STEPS: ScenarioStep[] = [
  'general',
  'layers',
  'model',
  'analogs',
  'wells',
  'economy',
  'calculations',
  'results',
];

export function parseScenarioStep(
  value: string | null | undefined,
  fallback: ScenarioStep,
): ScenarioStep {
  if (value && (SCENARIO_STEPS as string[]).includes(value)) {
    return value as ScenarioStep;
  }
  return fallback;
}

export function scenarioPathWithStep(
  basePath: string,
  step: ScenarioStep,
): string {
  const params = new URLSearchParams();
  params.set('step', step);
  return `${basePath}?${params.toString()}`;
}
